import {defineMessages} from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.networkError.title',
        defaultMessage: 'A network error occurred'
    },
    description: {
        id: 'app.networkError.description',
        defaultMessage: 'We have received the error and are going to look into the problem.'
    },
    refetchData: {
        id: 'app.networkError.refetchData',
        defaultMessage: 'Reload'
    },
    reloadPage: {
        id: 'app.networkError.reloadPage',
        defaultMessage: 'You can try to reload the page.'
    }
});
